@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Montana</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Coverage:</h3>
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 1) {
        <div class="axis-form-group _mt-medium">
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[0].formControlName)?.value === null ||
                reactiveForm.get(controls[0].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[0].formControlName)?.touched &&
                reactiveForm.get(controls[0].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
              @for (control of controls[0].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[0].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </div>
        </div>
      }

      <!-- UM Radio Group level two -->
      @if (controls?.length >= 2) {
        @if (baseRules?.Limits_UM_Text?.includes("show")) {
          <p>
            {{ textValues.Limits_UM_Text }}
          </p>
        }
        <div class="axis-form-group _mt-medium">
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[1].formControlName)?.value === null ||
                reactiveForm.get(controls[1].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[1].formControlName)?.touched &&
                reactiveForm.get(controls[1].formControlName)?.invalid,
              '_ml-large': baseRules.Show_Indent && controls[1].formControlName.endsWith('Radio'),
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
              @for (control of controls[1].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[1].formControlName }}"
                ></axis-radio>
              }
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </axis-radio-button-wrapper>
          </div>
        </div>
      }

      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4; track $index) {
          @if (control.formControlName.startsWith("UM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div class="axis-form-group">
                <div
                  class="axis-form-group _mt-medium"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                    '_ml-large': baseRules.Show_Indent && control.formControlName.endsWith('DropDown'),
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span class="axis-error-block">Please select an option.</span>
                    }
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["UM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="um_splitminlimits_25k_50k-pdffield-montana">
                {{ controls[7].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="um_combinedsingleminlimit_50k-pdffield-montana">
                {{ controls[8].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <h3 class="axis-h5">UIM Coverage:</h3>
      <!-- UIM Radio group level one -->
      @if (controls?.length >= 3) {
        <div class="axis-form-group _mt-large">
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[2].formControlName)?.value === null ||
                reactiveForm.get(controls[2].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[2].formControlName)?.touched &&
                reactiveForm.get(controls[2].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
              @for (control of controls[2].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[2].formControlName }}"
                ></axis-radio>
              }
              @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </axis-radio-button-wrapper>
          </div>
        </div>
      }

      <!-- UIM Radio group level two -->
      @if (controls?.length >= 4) {
        @if (baseRules?.Limits_UIM_Text?.includes("show")) {
          <p>
            {{ textValues.Limits_UIM_Text }}
          </p>
        }
        <div class="axis-form-group _mt-medium">
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[3].formControlName)?.value === null ||
                reactiveForm.get(controls[3].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[3].formControlName)?.touched &&
                reactiveForm.get(controls[3].formControlName)?.invalid,
              '_ml-large': baseRules.Show_Indent && controls[3].formControlName.endsWith('Radio'),
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
              @for (control of controls[3].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[3].formControlName }}"
                ></axis-radio>
              }
              @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </axis-radio-button-wrapper>
          </div>
        </div>
      }
      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 5; track $index) {
          @if (control.formControlName.startsWith("UIM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div class="axis-form-group">
                <div
                  class="axis-form-group _mt-medium"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                    '_ml-large': baseRules.Show_Indent && control.formControlName.endsWith('DropDown'),
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span class="axis-error-block">Please select an option.</span>
                    }
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["UIM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[11].label }}</label>
              <div id="uim_splitminlimits_25k_50k-pdffield-montana">
                {{ controls[11].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UIM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="uim_combinedsingleminlimit_50k-pdffield-montana">
                {{ controls[12].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <h3 class="axis-h5">Stacked Coverage Options:</h3>
      @for (control of controls | slice: 4 : 5; track $index) {
        @if (
          control.formControlName === "Stacked_Options_DropDown" &&
          (baseRules[control.formControlName]?.includes("show") || baseRules[control.formControlName]?.includes("form"))
        ) {
          <div class="axis-form-group">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(control.formControlName)?.value === null ||
                  reactiveForm.get(control.formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(control.formControlName)?.touched &&
                  reactiveForm.get(control.formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ control.formControlName }}"
              >
                {{ control.label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                class="_w-70"
                [dataProvider]="control.data"
                id="{{ control.formControlName }}"
                formControlName="{{ control.formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(control.formControlName)?.touched) {
                @if (reactiveForm.get(control.formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </div>
          </div>
        }
      }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Montana</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOneUM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues.Reject_UM_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Reject_LevelOneUIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UIM_Text }}
      </label>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 5; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}
